<template>
	<div>
		<div class="bg-grid"></div>
		<!-- Start Navbar -->
		<nav id="topnav" class="defaultscroll is-sticky">
			<div class="container">
				<!-- Logo container-->
				<a class="logo" href="/">
					<img src="../../assets/images/pp-logo-dark.svg" class="h-6 inline-block" alt="PPAPI Logo">
				</a>
				<!-- End Logo container-->

				<!-- Start Mobile Toggle -->
				<div class="menu-extras">
					<div class="menu-item">
						<a class="navbar-toggle" id="isToggle" @click="toggleMenu">
							<div class="lines">
								<span></span>
								<span></span>
								<span></span>
							</div>
						</a>
					</div>
				</div>
				<!-- End Mobile Toggle -->

				<!--Login button Start-->
				<ul class="buy-button list-none mb-0">
					<li class="inline mb-0">
						<a href="https://ai.pumpkinai.online" target="_blank">
							<span
								class="py-[6px] px-4 md:inline hidden items-center justify-center tracking-wider align-middle duration-500 text-sm text-center rounded bg-amber-400/5 hover:bg-amber-400 border border-amber-400/10 hover:border-amber-400 text-amber-400 hover:text-white font-semibold">登录</span>
							<span
								class="py-[6px] px-4 inline md:hidden items-center justify-center tracking-wider align-middle duration-500 text-sm text-center rounded bg-amber-400 hover:bg-amber-500 border border-amber-400 hover:border-amber-500 text-white font-semibold">登录</span>
						</a>
					</li>

					<li class="md:inline hidden ps-1 mb-0 ">
						<a href="https://ai.pumpkinai.online/register" target="_blank"
							class="py-[6px] px-4 inline-block items-center justify-center tracking-wider align-middle duration-500 text-sm text-center rounded bg-amber-400 hover:bg-amber-500 border border-amber-400 hover:border-amber-500 text-white font-semibold">注册</a>
					</li>
				</ul>
				<!--Login button End-->

				<div id="navigation">
					<!-- Navigation Menu-->
					<ul class="navigation-menu">
						<li><a href="#top" class="sub-menu-item">主页</a></li>
						<li><a href="https://login.pumpkin.lol" target="_blank" class="sub-menu-item">🔥AI对话，注册即用</a></li>
						<!-- <li><a href="/models.html#code-block" target="_blank" class="sub-menu-item">代码示例</a></li> -->
						<!-- <li><a href="#qa" class="sub-menu-item">常见问题</a></li> -->
						<li><a href="https://status.pumpkinai.online" target="_blank" class="sub-menu-item">接口监控</a></li>
					</ul><!--end navigation menu-->
				</div><!--end navigation-->
			</div><!--end container-->
		</nav><!--end header-->
		<!-- End Navbar -->

		<!-- Start Hero -->
		<section
			class="relative overflow-hidden pt-48 after:content-[''] after:absolute after:inset-0 after:mx-auto after:w-[56rem] after:h-[56rem] after:bg-gradient-to-tl after:to-amber-400/30  after:from-fuchsia-600/30 dark:after:to-amber-400/50 dark:after:from-fuchsia-600/50 after:blur-[200px] after:rounded-full after:-z-1">
			<div class="container relative z-2">
				<div class="grid grid-cols-1 text-center">
					<div class="">
						<h4 class="font-bold lg:leading-normal leading-normal text-4xl lg:text-6xl mb-5">
							<span class="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">
								8折
							</span>
							接入全球大模型<br>
							<span
								class="typewrite bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text"
								data-period="2000"
								data-type='[ "gpt-4", "gpt-4-turbo", "gpt-3.5-turbo", "claude-3-5-sonnet-20240620", "claude-3-5-sonnet-20241022", "claude-3-opus-20240229", "dall-e-3", "gemini-2.0-flash-thinking-exp-1219", "gemini-1.5-pro", "gpt-4o-2024-05-13", "gpt-4o-2024-08-06", "gpt-4o-2024-11-20", "gpt-4o-mini", "o1-mini", "o1-mini-2024-09-12", "o1-preview", "o1-preview-2024-09-12", "text-embedding-3-large", "text-embedding-3-small", "text-embedding-ada-002"]'></span>
							<span class="wrap"></span>
						</h4>
						<p class="text-slate-400 dark:text-white/60 text-lg max-w-xl mx-auto">

						<!-- <p class="text-slate-400 dark:text-white/60 text-lg max-w-xl mx-auto"
							style="padding: 10px; text-align: center;">仅修改
							<span
								class="font-bold text-white border-2 border-pink-500 rounded-lg px-2 py-1 hover:bg-pink-500">Key</span>和
							<span
								class="font-bold text-white border-2 border-pink-500 rounded-lg px-2 py-1 hover:bg-pink-500">Base
								url</span>就可使用
						</p> -->

						<div class="mt-6">
							<div class="flex justify-center gap-4">
								<a href="https://ai.pumpkinai.online/register" target="_blank"
									class="py-3 px-8 inline-block font-bold tracking-wide align-middle duration-500 text-lg text-center 
									bg-gradient-to-r from-yellow-400 via-amber-500 to-pink-600 hover:from-yellow-500 hover:via-amber-600 hover:to-pink-700
									text-yellow-50 hover:text-yellow-100 rounded-xl 
									shadow-[0_0_30px_rgba(251,191,36,0.3)] hover:shadow-[0_0_40px_rgba(251,191,36,0.5)] 
									transform hover:scale-105 transition-all animate-pulse
									relative overflow-hidden group">
									<div class="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
									<i class="mdi mdi-gift-outline me-2 text-xl text-yellow-50"></i>
									<span class="font-extrabold tracking-wider relative z-10 text-yellow-50 group-hover:text-yellow-100">
									领取免费体验额度<br/>
									
									<span class="text-sm font-medium opacity-90">GPT-4、Claude、Gemini等模型任选</span>
									</span>
								</a>
								<!-- <button @click="showQRCode = true"
									class="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-gradient-to-r from-fuchsia-500 to-pink-500 hover:from-fuchsia-600 hover:to-pink-600 border-transparent hover:border-transparent text-white rounded-md shadow-lg hover:shadow-xl transition-all">
									<i class="mdi mdi-headset me-1"></i>联系客服
								</button> -->
							</div>
						</div>
					</div>
					<div class="relative mt-4 z-3">
						<img src="../../assets/images/models-display.svg" 
							 alt="AI Models Display" 
							 class="w-full outline-none border-none models-display" 
							 style="background: transparent;">
					</div>
				</div><!--end grid-->
			</div>


		</section>
		<!-- End Hero -->



		<!-- Start -->
		<section class="relative md:py-24 py-16">
			<div class="container relative">
				<div class="grid grid-cols-1 pb-6 text-center">
					<h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">选择 <span
							class="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">
							PPAI</span> 的理由
					</h3>

					<p class="text-slate-400 max-w-xl mx-auto">PPAI是一站式AI大模型API聚合平台，致力于为开发者提供便捷、稳定、高性价比的AI能力接入方案。通过统一的API接口，即可轻松对接Openai、Claude、Gemini等全球顶尖大模型，让AI赋能变得简单高效。</p>
				</div><!--end grid-->

				<div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
					<div
						class="relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800">
						<div
							class="p-6 pb-0 relative overflow-hidden after:content-[''] after:absolute after:inset-0 after:mx-auto after:w-72 after:h-72 after:bg-gradient-to-tl after:to-amber-400 after:from-fuchsia-600 after:blur-[80px] after:rounded-full">
							<img src="../../assets/images/security-shield.svg"
								class="relative rounded-t-md shadow-md dark:shadow-slate-700 z-1" alt="数据安全保护">
						</div>

						<div class="p-6">
							<h5 class="text-lg font-semibold">安全：不保留任何用户请求内容</h5>
							<p class="text-slate-400 mt-3">PPAPI郑重声明，除为计算消耗而保留日志中的Token数值外，绝不记录或保存用户与大模型之间的任何交互内容。</p>
						</div>
					</div><!--end content-->

					<div
						class="relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800">
						<div
							class="p-6 pb-0 relative overflow-hidden after:content-[''] after:absolute after:inset-0 after:mx-auto after:w-72 after:h-72 after:bg-gradient-to-tl after:to-amber-400 after:from-fuchsia-600 after:blur-[80px] after:rounded-full">
							<img src="../../assets/images/price-discount.svg" class="relative rounded-t-md shadow-md dark:shadow-slate-700 z-1" alt="优惠价格">
						</div>

						<div class="p-6">
							<h5 class="text-lg font-semibold">优惠：直连原厂 低至8折</h5>
							<p class="text-slate-400 mt-3">与大模型原厂直接合作，采用集采模式，为您提供更具竞争力的价格，让AI赋能更经济实惠。</p>
						</div>
					</div><!--end content-->

					<div
						class="relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800">
						<div
							class="p-6 pb-0 relative overflow-hidden after:content-[''] after:absolute after:inset-0 after:mx-auto after:w-72 after:h-72 after:bg-gradient-to-tl after:to-amber-400 after:from-fuchsia-600 after:blur-[80px] after:rounded-full">
							<img src="../../assets/images/service-support.svg" class="relative rounded-t-md shadow-md dark:shadow-slate-700 z-1" alt="全天候服务">
						</div>

						<div class="p-6">
							<h5 class="text-lg font-semibold">服务：专业团队 随时响应</h5>
							<p class="text-slate-400 mt-3">专业技术支持团队全天候在线，快速响应各类需求，为您的业务保驾护航，让您使用无忧。</p>
						</div>
					</div><!--end content-->
				</div><!--end grid-->
			</div><!--end container-->

			<div class="container relative md:mt-24 mt-16">
				<div class="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
					<div
						class="relative overflow-hidden rounded-lg border border-amber-400/5 bg-gradient-to-tl to-amber-400/30 from-fuchsia-600/30 dark:to-amber-400/50 dark:from-fuchsia-600/50 ps-6 pt-6 lg:me-8">
						<img src="../../assets/images/api-flow.svg" 
							 class="ltr:rounded-tl-lg rtl:rounded-tr-lg" 
							 alt="API流程图">
					</div>

					<div class="">
						<h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold"><span
								class="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">一站式</span>大模型调用平台<br>覆盖全球头部AI能力
						</h3>
						<p class="text-slate-400 max-w-xl">
							PPAPI整合GPT-4、Claude、Gemini等全球顶尖大模型，提供统一的API接口。从文本理解到多模态生成，一个平台即可实现全方位AI能力。通过简单的接口调用，让您的应用立即获得世界级AI的强大支持。
						</p>

						<ul class="list-none text-slate-400 mt-4">
							<li class="mb-2 flex items-center"><i data-feather="check-circle"
									class="text-amber-400 h-5 w-5 me-2"></i>
								文本理解 | 图像生成 | 语音合成 | 视频创作</li>
							<li class="mb-2 flex items-center"><i data-feather="check-circle"
									class="text-amber-400 h-5 w-5 me-2"></i>
									智能客服 | 内容创作 | 知识问答 | 数据分析</li>
							<li class="mb-2 flex items-center"><i data-feather="check-circle"
									class="text-amber-400 h-5 w-5 me-2"></i>
									多语言翻译 | 代码生成 | 图像理解 | 语音识别</li>
						</ul>

						<div class="mt-4">
							<a href="https://ai.pumpkinai.online/register" target="_blank" 
								class="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg
								bg-gradient-to-r from-amber-400/10 to-fuchsia-600/10 
								hover:from-amber-400 hover:to-fuchsia-600
								text-amber-500 hover:text-yellow-50
								font-bold text-lg transition-all duration-300
								border border-amber-400/20 hover:border-transparent
								shadow-sm hover:shadow-lg group">
								<i class="mdi mdi-rocket-launch-outline text-xl"></i>
								<span>立即开启AI之旅</span>
								<i class="mdi mdi-arrow-right text-lg group-hover:translate-x-1 transition-transform"></i>
							</a>
						</div>
					</div>
				</div><!--end grid-->
			</div><!--end container-->


			<h2 id="qiye"></h2>
			<div class="container relative md:mt-24 mt-16">
				<div class="grid grid-cols-1 pb-6 text-center">
					<h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">企业级API服务能力<br> 
						<span class="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">
							稳定可靠的技术架构，专业贴心的服务保障
						</span>
					</h3>
					<p class="text-slate-400 max-w-xl mx-auto">
						为企业提供高性能、高可用的API服务，让您的业务运转更加高效稳定
					</p>
				</div><!--end grid-->

				<div class="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
					<!-- 最新：实时同步支持最新大模型 -->
					<div class="px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800 dark:hover:shadow-gray-700 duration-500 rounded-lg bg-white dark:bg-slate-900">
						<i class="mdi mdi-star-outline text-4xl bg-gradient-to-tl to-amber-400 from-fuchsia-600 text-transparent bg-clip-text"></i>

						<div class="content mt-7">
							<a href="" class="title h5 text-lg font-medium hover:text-amber-400 duration-500">
								最新：实时同步支持最新大模型
							</a>
							<p class="text-slate-400 mt-3">
								我们第一时间同步支持全球最新AI大模型，确保您始终使用最新技术。无缝接入前沿AI模型，提升应用性能和创新能力。
							</p>

							
						</div>
					</div>

					<!-- 正规：商务流程、合同、发票 -->
					<div class="px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800 dark:hover:shadow-gray-700 duration-500 rounded-lg bg-white dark:bg-slate-900">
						<i class="mdi mdi-comment-outline text-4xl bg-gradient-to-tl to-amber-400 from-fuchsia-600 text-transparent bg-clip-text"></i>

						<div class="content mt-7">
							<a href="javascript:void(0)" @click="showQRCode = true" class="title h5 text-lg font-medium hover:text-amber-400 duration-500">
								正规：商务流程、合同、发票
							</a>
							<p class="text-slate-400 mt-3">
								我们严格遵循商务流程，确保每一步操作都规范透明。从合同签署到发票开具，我们提供全程支持，确保您的每一笔交易都合法合规，真正做到安心合作、放心托付。
							</p>

							<div class="mt-5">
								<a href="javascript:void(0)" @click="showQRCode = true" 
									class="inline-flex items-center gap-2 px-4 py-2 rounded-lg 
									bg-gradient-to-r from-amber-400/10 to-fuchsia-600/10 
									hover:from-amber-400 hover:to-fuchsia-600
									text-amber-500 hover:text-yellow-50
									font-semibold transition-all duration-300
									border border-amber-400/20 hover:border-transparent
									shadow-sm hover:shadow-md">
									<i class="mdi mdi-briefcase-outline text-xl"></i>
									企业客户咨询
									<i class="mdi mdi-arrow-right text-lg"></i>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div><!--end container-->



			<div class="container relative md:mt-24 mt-16">
				<div class="grid grid-cols-1 pb-6 text-center">
				</div><!--end grid-->
			</div><!--end grid-->
		</section><!--end section-->
		<!-- End -->
		<!-- Start Footer -->
		<div class="relative">
			<div
				class="shape absolute xl:-bottom-[30px] lg:-bottom-[16px] md:-bottom-[13px] -bottom-[5px] start-0 end-0 overflow-hidden z-1 rotate-180 text-white dark:text-slate-900">
				<svg class="w-full h-auto scale-[2.0] origin-top" viewBox="0 0 2880 48" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
				</svg>
			</div>
		</div>
		<footer class="relative bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-900 overflow-hidden">
			<span
				class="absolute blur-[200px] w-[300px] h-[300px] rounded-full top-0 -start-[0] bg-gradient-to-tl to-amber-400  from-fuchsia-600 z-0"></span>
			<div class="container-fluid relative md:py-24 py-16">
				<div class="container relative">
					<div class="grid grid-cols-1 text-center">
						<div class="">
							<h4
								class="font-bold lg:leading-normal leading-normal text-4xl lg:text-5xl text-slate-800 dark:text-white tracking-normal mb-4">
								加入 <span class="bg-gradient-to-br from-amber-400 to-fuchsia-600 text-transparent bg-clip-text">PPAPI</span>
								<br>开启AI开发新时代
							</h4>
							<p class="text-slate-600 dark:text-slate-300 text-lg max-w-xl mx-auto">
								统一API接口，一站式接入全球顶尖大模型。文本、图像、语音、视频，多模态AI能力，助您快速构建智能应用。
							</p>
							
						</div>
					</div><!--end grid-->
				</div><!--end container-->
			</div><!--end container fluid-->

			<div class="container relative text-center">
				<div class="grid grid-cols-1 border-t border-slate-200 dark:border-slate-700">
					<div class="py-[30px] px-0">
						<div class="grid md:grid-cols-2 items-center">
							<div class="md:text-start text-center">
								<a href="#" class="text-[22px] focus:outline-none">
									<img src="../../assets/images/pp-logo-light.svg" class="mx-auto md:me-auto md:ms-0" alt="PPAPI Logo">
								</a>
							</div>
							<ul class="list-none footer-list md:text-end text-center mt-6 md:mt-0">
								<li class="inline"> <a href="#top"
										target="_blank">PPAI服务QQ群</a> 
									| <a href="https://status.pumpkinai.online" target="_blank">接口稳定性监控</a></li>
							</ul><!--end icon-->
						</div><!--end grid-->
					</div>
				</div><!--end grid-->
			</div><!--end container-->

			<div class="py-[30px] px-0 border-t border-slate-200 dark:border-slate-700">
				<div class="container relative text-center">
					<div class="grid grid-cols-1">
						<div class="text-center">
							<p class="text-slate-600 dark:text-slate-400">有问题联系管理员VX: tobemyslf</p>
						</div>
					</div><!--end grid-->
				</div><!--end container-->
			</div>
		</footer><!--end footer-->
		<!-- End Footer -->

		
		<!-- 修改为跳动的悬浮按钮 -->
		<div class="float-button" @click="showQrCode = true">
			<i class="mdi mdi-message-text-outline text-2xl"></i>
			<span class="button-text">联系客服</span>
		</div>

		<!-- 添加弹窗组件 -->
		<div v-if="showQRCode" class="qr-modal" @click.self="showQRCode = false">
			<div class="qr-content">
				<button class="close-button" @click="showQRCode = false">&times;</button>
				<img src="../../assets/images/qrcode.jpg" alt="联系客服">
				<div class="qr-text">扫码添加客服微信</div>
			</div>
		</div>






	</div>
</template>

<script>
	var TxtType = function(el, toRotate, period) {
		this.toRotate = toRotate;
		this.el = el;
		this.loopNum = 0;
		this.period = parseInt(period, 10) || 2000;
		this.txt = '';
		this.tick();
		this.isDeleting = false;
	};

	TxtType.prototype.tick = function() {
		var i = this.loopNum % this.toRotate.length;
		var fullTxt = this.toRotate[i];
		if (this.isDeleting) {
			this.txt = fullTxt.substring(0, this.txt.length - 1);
		} else {
			this.txt = fullTxt.substring(0, this.txt.length + 1);
		}
		this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';
		var that = this;
		var delta = 200 - Math.random() * 100;
		if (this.isDeleting) {
			delta /= 2;
		}
		if (!this.isDeleting && this.txt === fullTxt) {
			delta = this.period;
			this.isDeleting = true;
		} else if (this.isDeleting && this.txt === '') {
			this.isDeleting = false;
			this.loopNum++;
			delta = 500;
		}
		setTimeout(function() {
			that.tick();
		}, delta);
	};
	export default {
		name: 'my-index',
		data() {
			return {
				showQRCode: false,
			};
		},
		mounted() {
			// 设置页面标题
			document.title = 'PPAI - 一站式AI大模型API聚合平台';
			
			// 设置默认为浅色模式
			const htmlTag = document.getElementsByTagName("html")[0];
			htmlTag.className = 'light';
			
			this.typewrite();
			
			// 添加滚动监听
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			// 移除滚动监听
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			typewrite() {

				var elements = document.getElementsByClassName('typewrite');
				console.log(elements)
				for (var i = 0; i < elements.length; i++) {
					var toRotate = elements[i].getAttribute('data-type');
					var period = elements[i].getAttribute('data-period');
					if (toRotate) {
						new TxtType(elements[i], JSON.parse(toRotate), period);
					}
				}
				var css = document.createElement("style");
				css.type = "text/css";
				css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid transparent}";
				document.body.appendChild(css);
			},
			toggleMenu() {
				document.getElementById('isToggle').classList.toggle('open');
				var isOpen = document.getElementById('navigation')
				if (isOpen.style.display === "block") {
					isOpen.style.display = "none";
				} else {
					isOpen.style.display = "block";
				}
			},
			handleScroll() {
				const nav = document.getElementById('topnav');
				if (window.scrollY > 50) {  // 滚动超过50px时添加样式
					nav.classList.add('nav-sticky');
				} else {
					nav.classList.remove('nav-sticky');
				}
			},
		},
	}
</script>

<style>
	@import "../../assets/css/tailwind.css";

	/* 整体背景样式 */
	#app {
		min-height: 100vh;
		background: linear-gradient(135deg, 
			rgba(251, 191, 36, 0.03) 0%,
			rgba(255, 255, 255, 0.05) 50%,
			rgba(219, 39, 119, 0.03) 100%
		);
	}

	/* 添加动态背景网格 */
	.bg-grid {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-image: 
			linear-gradient(rgba(251, 191, 36, 0.05) 1px, transparent 1px),
			linear-gradient(90deg, rgba(251, 191, 36, 0.05) 1px, transparent 1px);
		background-size: 50px 50px;
		pointer-events: none;
		z-index: -1;
	}

	/* Hero区域样式优化 */
	.hero-section {
		position: relative;
		padding-top: 120px;
		padding-bottom: 80px;
		overflow: hidden;
	}

	.hero-section::before {
		content: '';
		position: absolute;
		top: -50%;
		left: -20%;
		width: 140%;
		height: 200%;
		background: radial-gradient(
			circle at center,
			rgba(251, 191, 36, 0.08) 0%,
			rgba(219, 39, 119, 0.08) 50%,
			transparent 70%
		);
		transform: rotate(-12deg);
		z-index: -1;
	}

	/* 卡片样式优化 */
	.feature-card {
		background: rgba(255, 255, 255, 0.9);
		backdrop-filter: blur(10px);
		border: 1px solid rgba(251, 191, 36, 0.1);
		border-radius: 16px;
		transition: all 0.3s ease;
	}

	.feature-card:hover {
		transform: translateY(-5px);
		box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
		border-color: rgba(251, 191, 36, 0.2);
	}

	/* 内容区域布局优化 */
	.content-section {
		position: relative;
		margin: 120px 0;
		padding: 60px 0;
	}

	.content-section::before {
		content: '';
		position: absolute;
		inset: 0;
		background: linear-gradient(
			135deg,
			rgba(251, 191, 36, 0.05) 0%,
			rgba(219, 39, 119, 0.05) 100%
		);
		border-radius: 30px;
		z-index: -1;
	}

	/* 导航栏样式优化 */
	#topnav.nav-sticky {
		background: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(20px);
		border-bottom: 1px solid rgba(251, 191, 36, 0.1);
	}

	/* 动态装饰元素 */
	.decoration-circle {
		position: absolute;
		border-radius: 50%;
		background: linear-gradient(135deg, rgba(251, 191, 36, 0.2), rgba(219, 39, 119, 0.2));
		filter: blur(50px);
		z-index: -1;
		animation: float 8s ease-in-out infinite;
	}

	@keyframes float {
		0%, 100% { transform: translateY(0) scale(1); }
		50% { transform: translateY(-20px) scale(1.05); }
	}

	/* Footer样式优化 */
	footer {
		background: linear-gradient(180deg, 
			rgba(255, 255, 255, 0.95) 0%,
			rgba(251, 191, 36, 0.05) 100%
		);
		backdrop-filter: blur(10px);
		border-top: 1px solid rgba(251, 191, 36, 0.1);
	}

	/* 响应式优化 */
	@media (max-width: 768px) {
		.hero-section {
			padding-top: 80px;
			padding-bottom: 60px;
		}
		
		.content-section {
			margin: 60px 0;
			padding: 40px 0;
		}
	}

	/* 新增悬浮按钮样式 */
	.float-button {
		position: fixed;
		right: 20px;
		bottom: 40px;
		background: linear-gradient(135deg, #F59E0B, #DB2777);
		color: white;
		padding: 12px 20px;
		border-radius: 24px;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		transition: all 0.3s ease;
		z-index: 1000;
		animation: bounce 2s infinite;
	}

	.float-button:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
	}

	.button-text {
		font-size: 14px;
		font-weight: 500;
	}

	/* 弹窗样式 */
	.qr-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1001;
		backdrop-filter: blur(4px);
		transition: all 0.3s ease;
	}

	.qr-content {
		background: white;
		padding: 32px;
		border-radius: 16px;
		position: relative;
		text-align: center;
		box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
		transform: scale(0.9);
		animation: modalPop 0.3s ease forwards;
	}

	.qr-content img {
		width: 200px;
		height: 200px;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	}

	.qr-text {
		margin-top: 16px;
		color: #1F2937;
		font-size: 18px;
		font-weight: 500;
	}

	.close-button {
		position: absolute;
		top: 8px;
		right: 8px;
		background: none;
		border: none;
		color: #6B7280;
		cursor: pointer;
		padding: 4px;
		font-size: 20px;
	}

	/* 跳动动画 */
	@keyframes bounce {
		0%, 20%, 50%, 80%, 100% {
			transform: translateY(0);
		}
		40% {
			transform: translateY(-10px);
		}
		60% {
			transform: translateY(-5px);
		}
	}

	/* 响应式调整 */
	@media (max-width: 768px) {
		.float-button {
			right: 16px;
			bottom: 32px;
			padding: 10px 16px;
		}
		
		.qr-content img {
			width: 160px;
			height: 160px;
		}
	}

	@keyframes modalPop {
		from {
			opacity: 0;
			transform: scale(0.8);
		}
		to {
			opacity: 1;
			transform: scale(1);
		}
	}
</style>